import { RootState } from '../store'

export const notificationsSelector = (state: RootState) => {
  const { notifications } = state

  return notifications
}
